<template>
  <div class="countries">
    <Header />
    <div id="country-content">
      <div class="countries">
        <router-link
          v-for="country in sortedCountries"
          :key="country.code"
          :class="`country link-${country.code}`"
          :to="`/${country.code}?source=${source}`"
          >{{ country.name }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import Header from '~/src/Header';
import { IMAGE_ROOT, LANG_CODE } from '~/utils/constants';

export default {
  components: { Header },
  props: {
    countries: Array
  },
  data() {
    return {
      trans: null
    };
  },
  computed: {
    sortedCountries() {
      return this.countries.sort((a, b) => {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      });
    },
    source() {
      const source = location.search
        .replace('?', '')
        .split('&')
        .map(query => query.split('='))
        .filter(pair => pair[0] === 'source');

      if (!!source && source.length > 0) return source[0][1];
      return 'no_source_provided';
    }
  }
};
</script>
